export enum APP_VIEW {
  ALL = 'ALL',
  OWNER = 'OWNER',
  CALENDAR = 'CALENDAR',
  MIN = 'MIN'
}

export const getAppView = (): APP_VIEW => {
  const appView = document.querySelector('[data-app-view]')?.getAttribute('data-app-view');
  return appView ? (appView as APP_VIEW) : APP_VIEW.ALL;
};
